import { render, staticRenderFns } from "./EditClassRegister.vue?vue&type=template&id=fbf9e73e&scoped=true&"
import script from "./EditClassRegister.vue?vue&type=script&lang=js&"
export * from "./EditClassRegister.vue?vue&type=script&lang=js&"
import style0 from "./EditClassRegister.vue?vue&type=style&index=0&id=fbf9e73e&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf9e73e",
  null
  
)

export default component.exports